import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Clock } from 'lucide-react';
import { createPageUrl } from '@/utils';

const PAGE_NAMES = {
  'DentalImplants': 'Dental Implants',
  'CosmeticDentistry': 'Cosmetic Dentistry',
  'Invisalign': 'Invisalign',
  'AllOn4NewPortRicheyFL': 'All-on-4 Implants',
  'EmergencyDentistry': 'Emergency Care',
  'Services': 'Our Services',
  'About': 'About Us',
  'Contact': 'Contact',
  'Blog': 'Blog'
};

export default function RecentlyViewed() {
  const [recentPages, setRecentPages] = useState([]);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const recent = JSON.parse(localStorage.getItem('recentlyViewed') || '[]');
    setRecentPages(recent.slice(0, 5));
  }, []);

  const clearRecent = () => {
    localStorage.setItem('recentlyViewed', '[]');
    setRecentPages([]);
  };

  if (recentPages.length === 0) return null;

  return (
    <div className="relative">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center gap-2 text-gray-700 hover:text-blue-600 transition-colors px-3 py-2 rounded-lg hover:bg-gray-50"
      >
        <Clock className="h-4 w-4" />
        <span className="text-sm font-medium hidden lg:block">Recent</span>
      </button>

      {isOpen && (
        <>
          <div 
            className="fixed inset-0 z-40" 
            onClick={() => setIsOpen(false)}
          />
          <div className="absolute right-0 mt-2 w-64 bg-white rounded-lg shadow-xl border border-gray-200 z-50">
            <div className="p-3 border-b border-gray-200 flex items-center justify-between">
              <div className="flex items-center gap-2">
                <Clock className="h-4 w-4 text-gray-600" />
                <h3 className="font-semibold text-gray-900 text-sm">Recently Viewed</h3>
              </div>
              <button
                onClick={clearRecent}
                className="text-gray-400 hover:text-gray-600 text-xs"
              >
                Clear
              </button>
            </div>
            <div className="py-2">
              {recentPages.map((page, idx) => (
                <Link
                  key={idx}
                  to={createPageUrl(page)}
                  onClick={() => setIsOpen(false)}
                  className="block px-4 py-2 text-sm text-gray-700 hover:bg-blue-50 hover:text-blue-600 transition-colors"
                >
                  {PAGE_NAMES[page] || page}
                </Link>
              ))}
            </div>
          </div>
        </>
      )}
    </div>
  );
}